import { IClickEventData } from 'types/analytics';

export const TEXT_KEYS = {
    TITLE: 'share-link__title',
    DESCRIPTION: 'share-link__description',
    COPY_BUTTON: 'share-link__copy-button',
    WARNING: 'share-link__warning',
    GAME_NAME: 'gameName'
};

export const COPY_KEY_BUTTON_ANALYTICS: IClickEventData = {
    location: 'page',
    category: 'interaction',
    action: 'copy custom url'
};

export const SHARE_LINK_QUERY_PARAM = 'refId';
